import { takeLatest, put, call, select } from 'redux-saga/effects';

import { COUPONS_FETCH_REQUEST } from '../actions/constants';
import { couponsFetchSuccess, couponsFetchError } from '../actions/coupons';
import { showMessage } from '../actions/message';

import { getUser } from '../selectors/user';

import { api } from '../utils/api';

function* fetchCoupons() {
  try {
    // @ts-ignore
    const user = yield select(getUser);
    const { data } = yield call(
      [api, api.get],
      `/user/${user.data.id}/coupons/list`,
      {
        Authorization: `Bearer ${user.data.token}`,
      }
    );

    yield put(couponsFetchSuccess(data));
  } catch {
    yield put(couponsFetchError());
    yield put(
      showMessage({
        message: 'Si è verificato un errore durante la ricerca dei tuoi coupon',
        type: 'danger',
      })
    );
  }
}

export function* couponsSaga() {
  yield takeLatest(COUPONS_FETCH_REQUEST, fetchCoupons);
}
